import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { first, Subject } from 'rxjs';
import { IDatagridSettings } from '@core-lib/models';
import { CarpaService } from './carpa.service';
import { IModesReceptionList, ModesReceptionCarpaSortableCols } from '@core-lib/models/mode-reception.model';
import { getListApiParamsFromDatagrid } from '@core-lib/functions';

@Injectable({
	providedIn: 'root'
})
export class ModeReceptionService {
	private readonly defaultModeReceptionDatagridSettings: IDatagridSettings<ModesReceptionCarpaSortableCols> = {
		name: '',
		pageNumber: 1,
		pageSize: 100,
		options: {},
		sort: {
			isAsc: true,
			column: ModesReceptionCarpaSortableCols.libelle
		}
	};

	private get carpaId(): string {
		return this.carpaService.currentCarpa?.id;
	}

	modesReception$: Subject<IModesReceptionList> = new Subject<IModesReceptionList>();

	constructor(
		private http: HttpClient,
		private carpaService: CarpaService
	) {}

	getModesReceptionCarpa(
		all: boolean,
		datagridSettings: IDatagridSettings<ModesReceptionCarpaSortableCols> = this.defaultModeReceptionDatagridSettings
	): void {
		const httpParams = getListApiParamsFromDatagrid(datagridSettings);
		let url: string = `${environment.apiUrl}/modereception/${this.carpaId}`;
		if (!all) {
			url = this.carpaId
				? `${environment.apiUrl}/modereception/Specifique/${this.carpaId}`
				: `${environment.apiUrl}/modereception/Commun`;
		}

		this.http
			.get<IModesReceptionList>(url, { params: httpParams })
			.pipe(first())
			.subscribe({
				next: modesReception => {
					this.modesReception$.next(modesReception);
				},
				error: () => {}
			});
	}

}
